module.exports = {
  zh: {
    // 左侧-菜单模块-中文配置
    moduleIndexMenu: {
      systemName: 'KRK幼儿园管理平台',
      chainParkManagement: '连锁园管理',
      gardenManagement: '园所管理',
      gardenInfo: '园所信息',
      schoolCalendar: '校历',
      classSetting: '班级设置',
      staffManagement: '职工管理',
      staffIndexList: '职工管理列表',
      staffInfoDetails: '职工信息详情',
      staffAdd: '添加职工',
      studentManagement: '学生管理',
      studentManagementList: '学生管理',
      studentDetails: '学生详情',
      parentsManagement: '家长管理',
      parentsManagementList: '家长管理',
      parentsDetails: '家长详情',
      enrollAndRecruit: '报名招生',
      enrollFormManagement: '报名表管理',
      channelGardenManagement: '园所渠道管理',
      channelManagement: '报名渠道管理',
      enrollmentDataFunnel: '招生数据漏斗',
      divisionStatistics: '分班统计',
      interviewQuestions: '面试题目管理',
      admissionsManagement: '招生管理',
      enrollmentManagement: '招生管理',
      applicationRegistration: '报名申请',
      registrationDetails: '报名申请详情',
      interviewAppointment: '面谈预约',
      interviewAppointmentDetails: '面谈预约详情',
      gardenChecking: '考核入园',
      gardenCheckingDetails: '考核入园详情',
      notificationManagement: '通知管理',
      homeSchoolCommunication: '家校沟通',
      newNotification: '新建通知',
      notificationList: '通知列表',
      suggest: '意见反馈',
      // latter add
      // offerSended: '招生管理-offer发出',
      // offerSendedDetails: 'offer发出详情',
      // confirmEnterGargen: '确认入园',
      // confirmEnterGargenDetails: '确认入园详情',
      // cancleEnterGargen: '取消入园',
      // cancleEnterGargenDetails: '取消入园详情',
      notificationListDisplay: '通知列表展示',
      notificationDetails: '通知详情',
      studentLeave: '学生请假',
      studentLeaveList: '学生请假列表',
      studentLeaveNew: '新建请假',
      studentLeaveDetails: '请假详情',
      chiefMailbox: '园长信箱',
      dailyManagement: '日报管理',
      activeTemplate: '活动模版',
      dailyUpload: '日报上传',
      dailyCheck: '日报查询',
      dailyDetails: '日报详情',
      siesta: '午睡',
      paymentManagement: '缴费管理',
      chargeSetting: '收费项目设置',
      chargeRecord: '收费记录',
      headquartersCharges: '园所收费项目',
      studentPrivilegeManagement: '学生优惠管理',
      attendanceManagementIndex: '考勤管理',
      attendanceIndex: '考勤看板',
      attendanceConfiguration: '考勤配置',
      attendancesManagement: '考勤组管理',
      monthlyStaffstatisticst: '职工月度统计',
      studentMonthlystatisticst: '学生月度统计',
      staffDailyStatistics: '职工每日统计',
      studentDailyStatistics: '学生每日统计',
      originalCatalog: '原始记录',
      applicationManagement: '应用管理',
      deviceManagement: '设备管理',
      personalManagement: '人员管理',
      menuManagement: '菜单管理',
      recipe: '幼儿食谱',
      dishes: '菜品定义',
      dailyMeal: '每周食谱',
      recipesDefine: '食谱定义',
      recipesNew: '新建食谱',
      recipesDetails: '食谱详情',
      menuDefine: '菜单定义',
      menuDefineList: '菜单定义列表',
      newWeeklySetMeal: '新建周套餐',
      newDailyroutine: '新建日套餐',
      WeeklySetMealDetails: '周套餐详情',
      dailyroutineDetails: '日套餐详情',
      classMunuConfig: '班级菜单配置',
      classDailyMenu: '班级每日菜单',
      foodDistributionStatistics: '配餐统计',
      scheduleManagement: '课程管理',
      scheduleCatagory: '课程分类',
      timetableSchedule: '课表时间安排',
      timetableScheduleList: '课表时间安排列表',
      timetableScheduleNew: '课表时间新建',
      timetableScheduleDetails: '课表时间详情',
      courseSeriesContent: '课程系列内容',
      courseSeriesContentList: '课程系列内容列表',
      courseSeriesContentNew: '课程系列内容新建',
      courseSeriesContentDetails: '课程系列内容详情',
      classCoursePlan: '班级课程计划',
      classCoursePlanList: '班级课程计划列表',
      classCoursePlanNew: '班级课程计划新建',
      classCoursePlanDetails: '班级课程计划详情',
      courseCalendarCheck: '课程日历查看',
      teachingCase: '教案',
      teachingCaseList: '教案列表',
      teachingCaseNew: '教案新建',
      teachingCaseDetails: '教案详情',
      authorityManagementIndex: '权限管理',
      user: '用户',
      role: '角色',
      systemSet: '系统设置',
      information: '基本信息',
      dictionaries: '字典设置',
      Journal: '日志管理',
      passwordChange: '密码修改',
      chargeBillManagement: '收费账单管理',
      refundBillManagement: '退款账单管理',
      billCensus: '账单统计',
      payQRCode: '当面付二维码',
      studentsChargeCensus: '学生收费统计',
      videoSurveillance: '视频监控',
      videoMonitoring: '班级摄像头管理',
      managementVideo: '摄像头配置',
      courseManagement: '课程管理',
      headquartersCourseManagement: '总部课程管理',
      gardenCourseManagement: '园所课程管理',
      classCourse: '班级课程',
      websiteNewsUpdate: '官网新闻更新',
      companyDynamic: '公司动态',
      gardenDynamic: '园所动态',
      shareDocuments: '共享中心',
      fileManagement: '文件管理',
      shareFile: '共享资料',
      eduParents: '凯小斯大学',
      eduSchool: '凯斯大学',
      eduMap: "总部培训地图",
      eduGardenMap: "园所培训地图",
      dailyRead: "日报已读数据"
    },
  },
  en: {
    // 左侧-菜单模块-英文配置
    moduleIndexMenu: {
      systemName: 'Kids ‘R‘ Kids Web',
      chainParkManagement: 'Manage Schools',
      gardenManagement: 'Administration',
      gardenInfo: 'School Information',
      schoolCalendar: 'School Calendar',
      classSetting: 'classSetting',
      staffManagement: 'staffManagement',
      staffIndexList: 'staffIndexList',
      staffInfoDetails: 'staffInfoDetails',
      staffAdd: 'staffAdd',
      studentManagement: 'studentManagement',
      studentManagementList: 'studentManagementList',
      studentDetails: 'studentDetails',
      parentsManagement: 'parentsManagement',
      parentsManagementList: 'parentsManagementList',
      parentsDetails: 'parentsDetails',
      enrollAndRecruit: 'enrollAndRecruit',
      enrollFormManagement: 'enrollFormManagement',
      channelGardenManagement: 'Registration Channel Garden Management',
      channelManagement: 'Registration Channel Management',
      enrollmentDataFunnel: 'Enrollment Data Funnel',
      divisionStatistics: 'divisionStatistics',
      interviewQuestions: 'InterviewQuestionsManagement',
      admissionsManagement: 'admissionsManagement',
      enrollmentManagement: 'Enrollment management',
      applicationRegistration: 'applicationRegistration',
      registrationDetails: 'registrationDetails',
      interviewAppointment: 'interviewAppointment',
      interviewAppointmentDetails: 'interviewAppointmentDetails',
      gardenChecking: 'gardenChecking',
      gardenCheckingDetails: 'gardenCheckingDetails',
      notificationManagement: 'notificationManagement',
      homeSchoolCommunication: 'homeSchoolCommunication',
      newNotification: 'newNotification',
      notificationList: 'notificationList',
      suggest: 'suggest',
      // latter add 
      // offerSended: 'offerSended',
      // offerSendedDetails: 'offerSendedDetails',
      // confirmEnterGargen: 'confirmEnterGargen',
      // confirmEnterGargenDetails: 'confirmEnterGargenDetails',
      // cancleEnterGargen: 'cancleEnterGargenDetails',
      // cancleEnterGargenDetails: 'cancleEnterGargenDetails',
      // divisionStatistics: 'divisionStatistics'
      notificationListDisplay: 'NotificationListDisplay',
      notificationDetails: 'NotificationDetails',
      studentLeave: 'studentLeave',
      studentLeaveList: 'studentLeaveList',
      studentLeaveNew: 'studentLeaveNew',
      studentLeaveDetails: 'studentLeaveDetails',
      chiefMailbox: 'chiefMailbox',
      dailyManagement: 'Daily Report',
      dailyUpload: 'Upload DR',
      dailyCheck: 'Search DR',
      dailyDetails: 'dailyDetails',
      siesta: 'Nap Time',
      paymentManagement: 'paymentManagement',
      chargeSetting: 'chargeSetting',
      chargeRecord: 'chargeRecord',
      headquartersCharges: 'Headquarters charges',
      studentPrivilegeManagement: 'Student privilege management',
      menuManagement: 'menuManagement',
      recipe: 'recipe',
      dishes: 'dishes',
      dailyMeal: 'dailyMeal',
      recipesDefine: 'recipesDefine',
      recipesNew: 'recipesNew',
      recipesDetails: 'recipesDetails',
      menuDefine: 'menuDefine',
      menuDefineList: 'menuDefineList',
      newWeeklySetMeal: 'newWeeklySetMeal',
      newDailyroutine: 'newDailyroutine',
      WeeklySetMealDetails: 'WeeklySetMealDetails',
      dailyroutineDetails: 'dailyroutineDetails',
      classMunuConfig: 'classMunuConfig',
      classDailyMenu: 'classDailyMenu',
      scheduleManagement: 'scheduleManagement',
      scheduleCatagory: 'scheduleCatagory',
      timetableSchedule: 'timetableSchedule',
      timetableScheduleList: 'timetableScheduleList',
      timetableScheduleNew: 'timetableScheduleNew',
      timetableScheduleDetails: 'timetableScheduleDetails',
      courseSeriesContent: 'courseSeriesContent',
      courseSeriesContentList: 'courseSeriesContentList',
      courseSeriesContentNew: 'courseSeriesContentNew',
      courseSeriesContentDetails: 'courseSeriesContentDetails',
      classCoursePlan: 'classCoursePlan',
      classCoursePlanList: 'classCoursePlanList',
      classCoursePlanNew: 'classCoursePlanNew',
      classCoursePlanDetails: 'classCoursePlanDetails',
      courseCalendarCheck: 'courseCalendarCheck',
      teachingCase: 'teachingCase',
      teachingCaseList: 'teachingCaseList',
      teachingCaseNew: 'teachingCaseNew',
      teachingCaseDetails: 'teachingCaseDetails',
      authorityManagementIndex: 'authorityManagementIndex',
      user: 'user',
      role: 'role',
      systemSet: 'systemSet',
      information: 'information',
      dictionaries: 'dictionaries',
      Journal: 'Log Query',
      passwordChange: 'password Set',
      attendanceManagementIndex: 'attendanceManagementIndex',
      attendanceIndex: 'attendanceIndex',
      attendanceConfiguration: 'attendanceConfiguration',
      attendancesManagement: 'attendancesManagement',
      monthlyStaffstatisticst: 'monthlyStaffstatisticst',
      studentMonthlystatisticst: 'studentMonthlystatisticst',
      staffDailyStatistics: 'staffDailyStatistics',
      studentDailyStatistics: 'studentDailyStatistics',
      originalCatalog: 'originalCatalog',
      applicationManagement: 'applicationManagement',
      deviceManagement: 'deviceManagement',
      personalManagement: 'personalManagement',
      activeTemplate: 'Schedule',
      chargeBillManagement: 'chargeBillManagement',
      refundBillManagement: 'refundBillManagement',
      billCensus: 'billCensus',
      payQRCode: 'payQRCode',
      studentsChargeCensus: 'studentsChargeCensus',
      videoSurveillance: 'Video surveillance',
      videoMonitoring: 'Class Camera Management',
      managementVideo: 'Camera configuration',
      courseManagement: 'Curriculum',
      headquartersCourseManagement: 'Headquarter',
      gardenCourseManagement: 'School',
      classCourse: 'Teacher',
      websiteNewsUpdate: 'Official website news update',
      companyDynamic: 'The company dynamic',
      gardenDynamic: 'Garden by dynamic',
      shareDocuments: 'Share documents',
      fileManagement: 'File management',
      shareFile: 'Shared data',
      eduParents: 'Kids Dojo',
      eduSchool: 'Kids School',
      eduMap: 'Hq training map',
      eduGardenMap: 'Garden trainning map',
      dailyRead: "Daily read data"
    },
  }

}




// WEBPACK FOOTER //
// ./src/components/i18n/lang/moduleIndexMenu.js